import React, { useState } from "react"
import { blog } from "../../dummydata"
import "./blog.css"

const PhotoGallery = () => {
  const [selectedCategory, setSelectedCategory] = useState("All")
  const [selectedPhoto, setSelectedPhoto] = useState(null)

  // Get all photos from all blog posts
  const allPhotos = blog.reduce((acc, post) => {
    const photos = [{ src: post.cover, title: post.title, category: post.category, postId: post.id }]
    if (post.additionalPhotos) {
      post.additionalPhotos.forEach(photo => {
        photos.push({ src: photo, title: post.title, category: post.category, postId: post.id })
      })
    }
    return [...acc, ...photos]
  }, [])

  // Filter photos by category
  const filteredPhotos = selectedCategory === "All" 
    ? allPhotos 
    : allPhotos.filter(photo => photo.category === selectedCategory)

  // Get unique categories
  const categories = ["All", ...new Set(blog.map(post => post.category))]

  const openPhotoModal = (photo) => {
    setSelectedPhoto(photo)
  }

  const closePhotoModal = () => {
    setSelectedPhoto(null)
  }

  return (
    <div className="photo-gallery-page">
      <div className="container">
        <div className="gallery-header">
          <h1>Photo Gallery</h1>
          <p>Explore our collection of photos from various programs, events, and activities</p>
        </div>

        {/* Category Filter */}
        <div className="gallery-filters">
          {categories.map((category) => (
            <button
              key={category}
              className={`gallery-category-btn ${selectedCategory === category ? 'active' : ''}`}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Results Count */}
        <div className="gallery-results">
          <p>Showing {filteredPhotos.length} photos from {selectedCategory === "All" ? "all categories" : selectedCategory}</p>
        </div>

        {/* Photo Grid */}
        <div className="gallery-grid">
          {filteredPhotos.map((photo, index) => (
            <div key={index} className="gallery-photo-item" onClick={() => openPhotoModal(photo)}>
              <img src={photo.src} alt={photo.title} />
              <div className="photo-info">
                <h4>{photo.title}</h4>
                <span className="photo-category">{photo.category}</span>
              </div>
              <div className="photo-overlay">
                <i className="fa fa-expand"></i>
                <span>Click to view</span>
              </div>
            </div>
          ))}
        </div>

        {/* No Results */}
        {filteredPhotos.length === 0 && (
          <div className="no-gallery-results">
            <i className="fa fa-images"></i>
            <h3>No photos found</h3>
            <p>Try selecting a different category</p>
          </div>
        )}
      </div>

      {/* Photo Modal */}
      {selectedPhoto && (
        <div className="photo-modal-overlay" onClick={closePhotoModal}>
          <div className="photo-modal" onClick={(e) => e.stopPropagation()}>
            <button className="photo-close-btn" onClick={closePhotoModal}>
              <i className="fa fa-times"></i>
            </button>
            <img src={selectedPhoto.src} alt={selectedPhoto.title} className="photo-modal-image" />
            <div className="photo-modal-info">
              <h3>{selectedPhoto.title}</h3>
              <p className="photo-category">{selectedPhoto.category}</p>
              <p>Click outside to close</p>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default PhotoGallery
